<template>
  <button class="header-filter" @click="handleFilter(enabled, $event)">
    {{ text }}
    <span v-if="enabled && count > 0">
      <b-icon v-if="clicked === null" icon="arrow-up-down"></b-icon>
      <b-icon v-else-if="clicked === true" icon="arrow-up"></b-icon>
      <b-icon v-else icon="arrow-down"></b-icon>
    </span>
  </button>
</template>

<script>
export default {
  name: "TableHeaderFilter",
  props: {
    text: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
    },
    headerFilterValue: {
      type: Array,
    },
    selected:{
        type: Number,
    },
    enabled:{
      type: Boolean,
    },
    count: {
      type: Number,
    },
  },
  data() {
    return {
      clicked: null,
    };
  },
  watch: {
    selected(newVal){
        if(newVal != this.id){
            this.clicked = null;
        }  
    }
  },
  methods: {
    handleFilter(enabled, event) {
      if (enabled && this.count > 0) {
        this.clicked = !this.clicked;
        let filter = '';
        if (this.clicked === true) {
          filter = 'asc';
        } else if (this.clicked === false) {
          filter = 'desc';
        }
        this.$emit('table-head-clicked', this.id, filter, event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-filter {
  border: none;
}
</style>
